import { action } from 'easy-peasy';

import { IActionResetActTeamStore } from '../types';

const resetActTeamStore: IActionResetActTeamStore = action(state => {
  state.availableActTeams = [];
  state.list = [];
});

export default resetActTeamStore;
